import { motion } from "framer-motion";

const SectionHeader = ({ title, subtitle1, subtitle2 }) => {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const stagger = {
    hidden: {},
    show: {
      transition: { staggerChildren: 0.12 },
    },
  };

  return (
    <>
      {/* TITULO */}
      <motion.div
        className="text-center mb-8"
        initial="hidden"
        animate="show"
        variants={fadeUp}
      >
        <h1 className="text-3xl md:text-5xl uppercase font-light tracking-[0.35em] text-[#B8977F]">
          {title}
        </h1>

        {/* Línea */}
        <motion.div
          className="w-full flex justify-center mt-4"
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <div className="w-full max-w-7xl h-[1px] bg-[#3C2B22]/60 origin-left" />
        </motion.div>
      </motion.div>

      {/* SUBTEXTO */}
      {(subtitle1 || subtitle2) && (
        <motion.div
          className="text-center max-w-3xl mx-auto mb-24 space-y-2"
          initial="hidden"
          animate="show"
          variants={stagger}
        >
          {subtitle1 && (
            <motion.p
              variants={fadeUp}
              className="text-[#D4BCAA] text-sm md:text-lg italic font-light leading-relaxed"
            >
              {subtitle1}
            </motion.p>
          )}

          {subtitle2 && (
            <motion.p
              variants={fadeUp}
              className="text-[#B8977F] text-sm md:text-base italic font-light leading-relaxed"
            >
              {subtitle2}
            </motion.p>
          )}
        </motion.div>
      )}
    </>
  );
};

export default SectionHeader;